import useIframeZoom from '@hooks/useIframeZoom'
import { Box } from '@mui/joy'
import { useIsAppControl } from '@store/isApp'
import { theme } from '@ui/style'
import pxToRem from '@utils/pxToRem'
import setAds from '@utils/setAds'
import { useLayoutEffect } from 'react'

type BottomAdProps = {
	index: number
}
const adList: Array<{
	id: string
	inventory: string
}> = [
	{
		id: 'm46Z1MQyT_SCEeWr8NY9FA',
		inventory: 'jtbc_m/article_news/article_news@article_news_middle_336x280?mlink=548',
	},
	{
		id: 's9_EfqUlRQGzv3h1OOMVJw',
		inventory: 'jtbc_m/article_news/article_news@article_news_bottom_300x250?mlink=27',
	},
]
const BottomAd = ({ index }: BottomAdProps) => {
	const { isApp } = useIsAppControl()
	const { id, inventory } = adList[index]
	const { iframeStyles } = useIframeZoom()
	useLayoutEffect(() => {
		if (!isApp) {
			setAds({ id, inventory })
		}
	}, [isApp])
	return (
		!isApp && (
			<Box
				display={{
					xs: 'block',
					md: 'none',
				}}
				id={`${id}_AD`}
				sx={{
					[theme.mediaQueries.under.origin]: {
						'#m46Z1MQyT_SCEeWr8NY9FA': {
							width: pxToRem(336),
							height: pxToRem(280),
							overflow: 'hidden',
							'&>iframe': iframeStyles,
						},
						'#s9_EfqUlRQGzv3h1OOMVJw': {
							width: pxToRem(300),
							height: pxToRem(250),
							overflow: 'hidden',
							'&>iframe': iframeStyles,
						},
					},
				}}
			/>
		)
	)
}
export default BottomAd
